import React from 'react';
import { Grid, GridColumn } from '@atlaskit/page';
import ViewTracker from '@atlassian/jira-analytics-web-react/src/components/view-tracker.tsx';
import { type IntlShape, injectIntl } from '@atlassian/jira-intl/src/index.tsx';

import error from '@atlassian/jira-servicedesk-common/src/utils/assets/error.svg';

import MessageCallToAction from '../common/message-call-to-action/view.tsx';
import PageHeader from '../common/page-header/view.tsx';
import messages from './messages.tsx';

type Props = {
	projectKey: string;
	enableHeader?: boolean;
} & { intl: IntlShape };

export function KnowledgeHubLoadingError({ intl, projectKey, enableHeader = true }: Props) {
	return (
		<Grid>
			<GridColumn>
				{enableHeader && (
					<>
						{/* @ts-expect-error - TS2769 - No overload matches this call. */}
						<PageHeader truncateTitle />
					</>
				)}
				<ViewTracker />

				<MessageCallToAction
					imageUrl={error}
					header={intl.formatMessage(messages.errorTitle)}
					description={intl.formatMessage(messages.errorBody)}
					primaryAction={
						<a href={`/jira/servicedesk/projects/${projectKey}/settings/confluence-kb`}>
							{intl.formatMessage(messages.errorCta)}
						</a>
					}
				/>
			</GridColumn>
		</Grid>
	);
}

export default injectIntl(KnowledgeHubLoadingError);
